import DashboardClickDrill from "../drill/DashboardClickDrill";

const PublicMode = {
  name: "public",
  drills: [DashboardClickDrill],
};

export default PublicMode;
